import { atom, selectorFamily } from 'recoil';
import { ObeService } from 'api';
export const obeBeingMovedRequestId = atom({
  default: 0,
  key: 'obeBeingMovedRequestId'
});
export const isObeBeingMoved = selectorFamily({
  key: 'isObeBeingMoved',
  get: obeId => async ({
    get
  }) => {
    get(obeBeingMovedRequestId);
    if (!obeId) return false;
    return ObeService.obeIsBeingMoved({
      obeId
    });
  }
});